import React, { useEffect, useState, useContext } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { 
    Box, 
    Button, 
    Typography, 
    Chip, 
    Grid,
    Accordion,
    AccordionActions,
    AccordionDetails,
    AccordionSummary,
    Tooltip,
    Modal,
    Divider,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Slider,
    Switch,
    Select,
    MenuItem,
    FormHelperText
} from '@mui/material';
import { fetchToken, fetchRole } from '../auth/Token';
import { api } from '../api';
import Menu from '@mui/material/Menu';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import AuthContext from "../auth/AuthProvider";
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import { useFormik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    marginBottom:'150px',
    overflowY: 'auto', 
    maxHeight:'550px', 
    '&::-webkit-scrollbar': {
        width: '5px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
    } 
}));

const ItemCard = styled(Paper)(({ theme }) => ({
    backgroundColor: '#52b788',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    margin: '10px' 
}));

const ItemCardI = styled(Paper)(({ theme }) => ({
    backgroundColor: '#b7e4c7',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    margin: '10px' 
}));

const ItemCardSS = styled(Paper)(({ theme }) => ({
    backgroundColor: '#52b788',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    margin: '5px' 
}));

const ItemCardSI = styled(Paper)(({ theme }) => ({
    backgroundColor: '#b7e4c7',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    margin: '5px' 
}));

function formatDateToYearMonthDay(date) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = 'th';
  
    if (day === 1 || day === 21 || day === 31) {
      suffix = 'st';
    } else if (day === 2 || day === 22) {
      suffix = 'nd';
    } else if (day === 3 || day === 23) {
      suffix = 'rd';
    }
  
    return `${day}${suffix} ${month} ${year}`;
  }
  
  const isToday = (someDate) => {
    const today = new Date();
    return someDate.getDate() === today.getDate() &&
           someDate.getMonth() === today.getMonth() &&
           someDate.getFullYear() === today.getFullYear();
  };
  
  const renderTitle = (name, date) => {
    const formattedDate = formatDateToYearMonthDay(date);
    return (
      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
        <b>{name}: {formattedDate}</b>
      </Typography>
    );
  };

  const renderTitleDate = (date) => {
    const formattedDate = formatDateToYearMonthDay(date);
    return (
        <b>{formattedDate}</b>
    );
  };


  const PrettoSlider = styled(Slider)({
    color: '#52af77',
    height: 8,
    '& .MuiSlider-track': {
      border: 'none',
    },
    '& .MuiSlider-thumb': {
      height: 24,
      width: 24,
      backgroundColor: '#fff',
      border: '2px solid currentColor',
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: 'inherit',
      },
      '&::before': {
        display: 'none',
      },
    },
    '& .MuiSlider-valueLabel': {
      lineHeight: 1.2,
      fontSize: 12,
      background: 'unset',
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: '#52af77',
      transformOrigin: 'bottom left',
      transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
      '&::before': { display: 'none' },
      '&.MuiSlider-valueLabelOpen': {
        transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
      },
      '& > *': {
        transform: 'rotate(45deg)',
      },
    },
  });

  
  function ChildModal({
    setMessage,
    setOpe,
    confirm_request, 
    printRef, 
    formik,
    data,
    charges_ware,
    props,
    handleConfirmOrder,
    handlePrint,
    modal_type,
    outstanding_loan,
    paid_savings,
    paid_name,
    withe,
    handleWithdraw,
    loading
}) {
    const [settle_bags, setSettle_bags] = useState([])
    const [bags, setBags] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const calcBagsToHold = () => {
        if(formik.values.rebag === true){
            if(!bags){
                api.post('/account/calc/number/bags/to/hold/and/amount/to/pay', data, {
                    headers: {
                        Authorization: 'Bearer ' + fetchToken(),
                    }
                }).then(function (response){
                    setSettle_bags(response.data);
                    setBags(true);
                }).catch(function(error){
                    console.log(error)
                })
            }else{
                handleConfirmOrder(0, 
                    settle_bags?.charged_price_per_bg, 
                    settle_bags?.bags_for_loan_repayment,
                    settle_bags?.balance,
                    settle_bags?.remaining_bags,
                    settle_bags?.remaining_bags_value)
            }
            
        }else{
            setMessage('Crop needs to be rebaged')
            setOpe(true)
        }
        
    }

    const [openn, setOpenn] = useState(true);
    const handleOpen = () => {
      setOpenn(true);
    };
    const handleClosee = () => {
      setOpenn(false);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
    });

    const handleConfirm = (savings_id) => {
        handleConfirmOrder(savings_id);
    };


    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 640,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };
    
  
    return (
        <Modal
            open={openn}
            onClose={handleClosee}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
                {
                    confirm_request?
            <Box sx={style}>
                    <>
                        <div ref={printRef} style={{ display:'block', marginBottom:5 }}>
                            <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='body2' sx={{ textAlign: 'center',mb:2}}>~The Cooperative~</Typography>

                            <Typography variant='h5'   fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                {
                                    modal_type?
                                    (<b>{withe === 'yes'? 'Commodity Withdrawal': 'Commodity Storage'}</b>)
                                    :
                                    (<b>Loan Repayment</b>)
                                }
                                
                            </Typography>
                            <Chip sx={{ display:'flex', mt:1, mb:1  }} label={confirm_request.Commodity} variant='outlined' color='success'/>
                            <Divider variant='middle' sx={{mt:1, mb:1}}><i>Member Details</i></Divider>
                            
                            <div>
                                <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='body2'><b>Date: {renderTitleDate(new Date(formik.values.date))}</b></Typography>
                                <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='body2'><b>Member: {props.member}</b></Typography>
                                <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='body2'><b>Passbook: {props.passbook}</b></Typography>
                                <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='body2'><b>Society: {props.society}</b></Typography>
                                <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='body2'><b>Kind: {props.kind}</b></Typography>
                                <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='body2'><b>Savings Group: {props.association}</b></Typography>
                                <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='body2'><b>Season: {props.name}</b></Typography>  
                            </div>

                            <Divider variant='middle' sx={{mt:2, mb:2}}><i>Commodity Specification</i></Divider>
                        <div style={{ display:'flex', flexDirection:'row' }}>
                            <div style={{ display:'flex', justifyContent:'space-between' }}>
                            <div style={{ display:'block' }}>
                            <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Grade: {confirm_request.Grade}</b> </Typography>
                            <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Current {confirm_request.Commodity} price: {currencyFormat.format(confirm_request.Current_commodity_price)}</b> </Typography>
                            <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Number of Bags: {confirm_request.Amount_storing} </b> </Typography>
                            <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Units: {confirm_request.Unit_kg}kg</b> </Typography>
                            <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Weight: {confirm_request.Weight}kg </b> </Typography>
                            <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Tonnes: {confirm_request.Tons}</b> </Typography>
                            <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Price per bag: {currencyFormat.format(confirm_request.Price_per_bag)}</b> </Typography>
                            <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Price per bag(charged): {currencyFormat.format(confirm_request.charged_price_per_bg)}</b> </Typography>
                            <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Cash value: {currencyFormat.format(confirm_request.forsettlement)}</b> </Typography>
                            {
                                modal_type?
                                <>
                                    <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Price per bag (Charged): {currencyFormat.format(confirm_request.charged_price_per_bg)}</b> </Typography>
                                    <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Loan repaid: {currencyFormat.format(outstanding_loan)}</b> </Typography>
                                    {
                                        paid_savings === true?
                                        <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Loan repaid from your: {paid_name}</b> </Typography>
                                        :
                                        null
                                    }
                                    <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Current cash value: {paid_savings === true?currencyFormat.format(confirm_request.forsettlement): currencyFormat.format(confirm_request.forsettlement - outstanding_loan)}</b> </Typography>
                                </>
                                :
                                <>
                                    {
                                        paid_savings === true?
                                        <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Loan repaid from your: {paid_name}</b> </Typography>
                                        :
                                        null
                                    }
                                    <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Outstanding loan: {currencyFormat.format(outstanding_loan)}</b> </Typography>
                                    <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Cash value after loan repayment: {currencyFormat.format(confirm_request.forsettlement - outstanding_loan)}</b> </Typography>
                                </>
                            }
                            </div>
                            {
                                bags?
                                <div>
                                    <Typography variant='h6' sx={{textAlign:'center'}}  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Settling Debt With Bags</b> </Typography>
                                    <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Price per bag: {currencyFormat.format(settle_bags?.charged_price_per_bg)}</b> </Typography>
                                    <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Bags to be held: {settle_bags?.bags_for_loan_repayment}</b> </Typography>
                                    <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Balance: {currencyFormat.format(settle_bags?.balance)}</b> </Typography>
                                    <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Remaining Bags: {settle_bags?.remaining_bags}</b> </Typography>
                                    <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Remaining Bags Value: {currencyFormat.format(settle_bags?.remaining_bags_value)}</b> </Typography>
                                </div>
                                :
                                null
                            }
                            
                        </div>
                        
                            {
                                modal_type?
                                    <div style={{ display:'block', marginLeft:'3px', borderColor:'blue' }}>
                                        {
                                            charges_ware[0]?
                                            <>
                                                <Typography variant='subtitle' fontStyle='oblique' fontFamily='Futura'><b><u>Charges associated</u></b></Typography>
                                                <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Rebag ({currencyFormat.format(charges_ware[0]?.rebagging_fee)}): {formik.values.rebag === true? 'paid':'no rebaging'}</b> </Typography>
                                                <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Stack ({currencyFormat.format(charges_ware[0]?.stacking_fee)}): {formik.values.stack === true? 'paid':'no stacking'}</b> </Typography>
                                                <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Clean ({currencyFormat.format(charges_ware[0]?.cleaning_fee)}): {formik.values.clean === true? 'paid':'no cleaning'}</b> </Typography>
                                                <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Destone ({currencyFormat.format(charges_ware[0]?.destoning_fee)}): {formik.values.destone === true? 'paid':'no destoning'}</b> </Typography>
                                                <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Store ({currencyFormat.format(charges_ware[0]?.storage_fee)}): {formik.values.store === true? 'paid':'no storage_fee'}</b> </Typography>
                                                <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Stitch ({currencyFormat.format(charges_ware[0]?.stitching_fee)}): {formik.values.stitch === true? 'paid':'no stitching'}</b> </Typography>
                                                <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Load ({currencyFormat.format(charges_ware[0]?.loading_fee)}): {formik.values.load === true? 'paid':'no loading'}</b> </Typography>
                                                <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Empty Sack ({currencyFormat.format(charges_ware[0]?.empty_sack_cost_fee)}): {formik.values.empty_sack === true? 'paid':'no empty sack'}</b> </Typography>
                                                <Typography variant='h6'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Tax ({currencyFormat.format(charges_ware[0]?.tax_fee)}): paid</b> </Typography>
                                            </>
                                            :
                                            <Box sx={{ width: '100%', justifyContent:'center' }}>
                                                <CircularProgress size='15'/>
                                            </Box>
                                        }
                                
                                    </div>
                                    :
                                    null
                            }
                           
                        </div>
                            
                        </div>
                            <Typography sx={{ mt:2 }} variant='subtitle'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Print:</b></Typography>
                            <IconButton onClick={handlePrint}><SummarizeIcon size='small'/></IconButton>
                        <div style={{ display:'flex', flexDirection: 'row' }}>
                        <Button
                            variant='contained'
                            onClick={handleClosee}
                            color='error'
                            size='small'
                            sx={{ m:1 }}
                        >
                            Cancel
                        </Button>
                        {
                            modal_type === true && withe !== 'yes'?
                                <>
                                    <Button
                                        variant='contained'
                                        onClick={() => handleConfirmOrder(null)}
                                        color='success'
                                        size='small'
                                        sx={{ m:1 }}
                                    >
                                        Transfer
                                    </Button>
                                </>
                            :modal_type === false && withe !== 'yes'?
                                <>
                                        {
                                        confirm_request.forsettlement <= outstanding_loan?
                                        <>
                                            <Typography sx={{ mt:2 }} variant='subtitle'  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Commodity value is unable to settle debt.</b>
                                            </Typography>
                                            <Button
                                                variant='contained'
                                                color='success'
                                                size='small'
                                                onClick={handleClick}
                                                sx={{   m:1, 
                                                    borderRadius:4,
                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                    minWidth: 0,
                                                    '&:hover': {
                                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                    backgroundColor:'#80ed99',
                                                    color:'#000'
                                                    },
                                                }} 
                                                id="demo-positioned-button"
                                                aria-controls={open ? 'demo-positioned-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={open ? 'true' : undefined}
                                            >
                                                Settle with savings
                                            </Button>
                                            <Menu
                                                id="demo-positioned-menu"
                                                aria-labelledby="demo-positioned-button"
                                                anchorEl={anchorEl}
                                                open={open}
                                                onClose={handleClose}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left'
                                                }}
                                            >
                                                {
                                                    props.savings_acc.map((item)=>(
                                                        <MenuItem disabled={item.Current_Balance < outstanding_loan} onClick={() => handleConfirm(item.ID)}>
                                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>{item.Account_Name} || {currencyFormat.format(item.Current_Balance)}</b>
                                                            </Typography>
                                                        </MenuItem>
                                                    ))
                                                }
                                                <MenuItem onClick={handleClose}>
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>Cancel</b>
                                                    </Typography>
                                                </MenuItem>
                                            </Menu>
                                        </>
                                        :
                                        <>
                                            <Button
                                                variant='contained'
                                                color='success'
                                                size='small'
                                                sx={{ borderRadius:3,m:1 }}
                                                onClick={calcBagsToHold}
                                            >
                                                {
                                                    bags?
                                                    'Confirm'
                                                    :
                                                    'Settle with commodity value'
                                                }
                                            </Button>
                                            <Button
                                                variant='contained'
                                                color='success'
                                                size='small'
                                                onClick={handleClick}
                                                sx={{   m:1, 
                                                    borderRadius:4,
                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                    minWidth: 0,
                                                    '&:hover': {
                                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                    backgroundColor:'#80ed99',
                                                    color:'#000'
                                                    },
                                                }} 
                                                id="demo-positioned-button"
                                                aria-controls={open ? 'demo-positioned-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={open ? 'true' : undefined}
                                            >
                                                Settle with savings
                                            </Button>
                                            <Menu
                                                id="demo-positioned-menu"
                                                aria-labelledby="demo-positioned-button"
                                                anchorEl={anchorEl}
                                                open={open}
                                                onClose={handleClose}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left'
                                                }}
                                            >
                                                {
                                                    props.savings_acc.map((item)=>(
                                                        <MenuItem disabled={item.Current_Balance < outstanding_loan} onClick={() => handleConfirm(item.ID)}>
                                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>{item.Account_Name} || {currencyFormat.format(item.Current_Balance)}</b>
                                                            </Typography>
                                                        </MenuItem>
                                                    ))
                                                }
                                                <MenuItem onClick={handleClose}>
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>Cancel</b>
                                                    </Typography>
                                                </MenuItem>
                                            </Menu>
                                        </>
                                        
                                }
                            </>: modal_type === false && withe === 'yes'?
                                            <Button
                                                disabled={loading}
                                                variant='contained'
                                                onClick={handleWithdraw}
                                                color='success'
                                                size='small'
                                                sx={{ m:1 }}
                                            >
                                                Withdraw
                                            </Button>
                                        : null
                        }
                        
                        
                        </div>
                    </>
            </Box>
                    :
                    <Box sx={{ width: '100%', justifyContent:'center' }}>
                    <CircularProgress size='15'/>
                    </Box>
                }
            </Modal>

    )
}

export default function SeasonDetails(props) {
    const [details, setDetails] = useState([])
    const [ope, setOpe] = useState(false);
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState()
    const {  permissions } = useContext(AuthContext);
    const [start_date, setStart_date] = useState('')
    const [end_date, setEnd_date] = useState('')
    const member_acc_id = props.ID;
    const [deep_details, setDeep_details] = useState();
    const [deeper_details, setDeeper_details] = useState();
    const [current_services, setCurrent_services] = useState([]);
    const [current_inputs, setCurrent_inputs] = useState([]);
    const [open, setOpen] = useState(false);
    const [modal_open, setModal_open] = useState(false);
    const [modal_type, setModal_type] = useState(false);
    const [crops, setCrops] = useState([]);
    const [service_subscribed, setService_subscribed] = useState([]);
    const [input_subscribed, setInput_subscribed] = useState([]);
    const [hold_crop, setHold_crop] = useState('');
    const [hold_crop_id, setHold_crop_id] = useState(null);
    const [hold_acres, setHold_acres] = useState(null);
    const [slider_value, setSlider_value] = useState(1);
    const [subscribed_s, setSubscribed_s] = useState([]);
    const [subscribed_i, setSubscribed_i] = useState([]);
    const [openn, setOpenn] = React.useState(false);
    const [bags_clock, setBags_clock] = useState(null);
    const [bags_unit, setBags_unit] = useState(null);
    const [per, setPer] = useState(true);
    const [warehouses, setWarehouses] = useState([])
    const [grade_price, setGrade_price] = useState([]);
    const [available_units, setAvailable_units] = useState([]);
    const [charges, setCharges] = useState([
        {
            index_id: 0,
            charge: null,
            amount_per: null
        }
    ]);
    const [charges_done, setCharges_done] = useState();
    const [charges_ware, setCharges_ware] = useState([]);
    const [confirm_request, setConfirm_request] = useState([]);
    const [second_modal, setSecond_modal] = useState();
    const [cash_hold, set_cash_hold] = useState(null);
    const [paid_savings, setPaid_savings] = useState(false);
    const [paid_name, setPaid_name] = useState('');
    const [withe, setWithe] = useState('');
    const [myWarehouse, setMyWarehouse] = useState()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openg = Boolean(anchorEl);

    const handleConfirm = (id) => {
        const data = new FormData()
        data.append('prod_id', deeper_details.id)
        data.append('warehouse_id', id)
        api.post('/account/set/prod_id/warehouse', data,{
            headers: {
              Authorization: 'Bearer '+ fetchToken()
            }
          }).then(function(response){
              setMessage(response.data)
              setOpe(true)
              handleClose()
              fetch_details_trs()
          }).catch(function(error){
            console.log(error)
          })
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const Withdraw = () => {
        setModal_open(true);
        setWithe('yes')
        setModal_type(false)
    }


    const formik = useFormik({
        initialValues: {
          grade_id: null,
          unit_id: null,
          member_com_acc: null,
          rebag: false,
          stack: false,
          clean: false,
          destone: false,
          store: true,
          stitch: false,
          load: true,
          empty_sack: false,
          date: dayjs()
      },
      onSubmit: (values) => {
          handleOpen()
          const data = new FormData()
          data.append('commodity_id', hold_crop_id)
          data.append('grade_id', values.grade_id)
          data.append('unit_id', values.unit_id)
          data.append('amount_storing', bags_clock)
          data.append('member_com_acc', values.member_com_acc?values.member_com_acc:0)
          data.append('rebag', values.rebag)
          data.append('stack', values.stack)
          data.append('clean', values.clean)
          data.append('destone', values.destone)
          data.append('store', values.store)
          data.append('stitch', values.stitch)
          data.append('load', values.load)
          data.append('empty_sack', values.empty_sack)
          api.post('/account/process/storage', data ,{
            headers: {
              Authorization: 'Bearer ' + fetchToken()
            }
          }).then(function (response){
            setConfirm_request(response.data);
            set_cash_hold(response.data.forsettlement);
            setSecond_modal(
            <ChildModal 
                setMessage={setMessage}
                setOpe={setOpe}
                confirm_request={response.data}
                printRef={printRef}
                formik={formik}
                data={
                    {
                        "loan_amount": deeper_details.accumulative_cost,
                        "charged_price_per_bg": response.data?.charged_price_per_bg,
                        "Amount_storing": bags_clock,

                    }
                }
                charges_ware={charges_ware}
                props={props}
                handleConfirmOrder={handleConfirmOrder}
                handlePrint={handlePrint}
                modal_type={modal_type}
                outstanding_loan={deeper_details.accumulative_cost}
                paid_savings={paid_savings}
                paid_name={paid_name}
                withe={withe}
                handleWithdraw={handleWithdraw}
                loading={loading}
            />
        );
          }).finally(function (){
            handleCloses();
          })
      }
    })

    const handleWithdraw = () => {
        setLoading(true)
        handleOpen()
        const bks = new FormData()
        bks.append('prod_id', deeper_details.id)
        api.post('/account/member/prod_id/withdraw', bks, {
            headers: {
                Authorization: 'Bearer ' + fetchToken(),
                'Content-Type': 'multipart/form-data', 
                
            }
        }).then(function (response){
            formik.handleReset();
            handle_modal_Closee();
            setMessage(response.data);
            setOpe(true);
            props.fetchAccounts();
            closeStore();
            fetch_details_trs();
        }).catch(function(error){
            console.log(error)
        }).finally(function (){
            setLoading(false);
            handleCloses()
        })
    }

    const [loading, setLoading] = useState(false)
    

  const handleConfirmOrder = (save_id, 
    charged_price_per_bg,
    bags_for_loan_repayment,
    balance,
    remaining_bags,
    remaining_bags_value
  ) => {
    setLoading(true)
    handleOpen()
    if(modal_type ===true){
        const data = new FormData()
            data.append('commodity_id', hold_crop_id)
            data.append('grade_id', formik.values.grade_id)
            data.append('unit_id', formik.values.unit_id)
            data.append('amount_storing', remaining_bags?remaining_bags: bags_clock)
            data.append('member_com_acc', formik.values.member_com_acc?formik.values.member_com_acc:0)
            data.append('rebag', formik.values.rebag)
            data.append('stack', formik.values.stack)
            data.append('clean', formik.values.clean)
            data.append('destone', formik.values.destone)
            data.append('store', formik.values.store)
            data.append('stitch', formik.values.stitch)
            data.append('load', formik.values.load)
            data.append('empty_sack', formik.values.empty_sack)

            api.post('/account/process/storage', data ,{
                headers: {
                Authorization: 'Bearer ' + fetchToken()
            }
        }).then(function (response){
            const sk = new FormData()
            sk.append('transaction_date', formik.values.date) 
            sk.append('commodity_acc_id', formik.values.member_com_acc)
            sk.append('number_of_commodities', bags_clock)
            sk.append('commodities_id', hold_crop_id)
            sk.append('cash_value', save_id === 0? response.data.forsettlement: (response.data.forsettlement - deeper_details.accumulative_cost))
            sk.append('transaction_type_id', 1)
            sk.append('grade_id', formik.values.grade_id)
            sk.append('units_id', formik.values.unit_id)
            sk.append('weight', (bags_unit * bags_clock))
            sk.append('tons', response.data.Tons)
            sk.append('rebag',formik.values.rebag)
            sk.append('stack',formik.values.stack)
            sk.append('clean',formik.values.clean)
            sk.append('destone',formik.values.destone)
            sk.append('stitch',formik.values.stitch)
            sk.append('empty_sack',formik.values.empty_sack)
            sk.append('charged_price_per_bg',charged_price_per_bg)
            sk.append('bags_for_loan_repayment',bags_for_loan_repayment)
            sk.append('balance',balance)
            sk.append('remaining_bags',remaining_bags)
            sk.append('remaining_bags_value',remaining_bags_value)
            sk.append('prod_id', deeper_details.id)
            sk.append('savings_id', save_id)
            
            
            api.post('/account/store/commodity/original', sk, {
                headers: {
                    Authorization: 'Bearer ' + fetchToken(),
                    'Content-Type': 'multipart/form-data', 
                }
            }).then(function (response){
                formik.handleReset();
                handle_modal_Closee();
                setMessage(response.data);
                setOpe(true);
                fetch_details_trs();
                closeStore();
            }).catch(function(error){
                console.log(error)
            }).finally(function (){
                setLoading(false);
                handleCloses()
            })
        })
        
    }else{

        const bk = new FormData()
        bk.append('prod_id', deeper_details.id)
        bk.append('sava', save_id)
        bk.append('grade_id', formik.values.grade_id)
        bk.append('units_id', formik.values.unit_id)
        bk.append('bags_for_loan_repayment',bags_for_loan_repayment)
        bk.append('balance',balance)
        bk.append('remaining_bags',remaining_bags)
        bk.append('remaining_bags_value',remaining_bags_value)
        
        api.post('/account/member/prod_id/repayment', bk, {
            headers: {
                Authorization: 'Bearer ' + fetchToken(),
                'Content-Type': 'multipart/form-data', 
                
            }
        }).then(function (response){
            formik.handleReset();
            handle_modal_Closee();
            setMessage(response.data);
            setOpe(true);
            props.fetchAccounts();
            closeStore();
            fetch_details_trs();
        }).catch(function(error){
            console.log(error)
        }).finally(function (){
            setLoading(false);
            handleCloses()
        })
    }
    
  }

  const handle_modal_Closee = () => {
    setSecond_modal(false)
    setGrade_price([]);
  }

    useEffect(()=>{
        if(formik.values.member_com_acc){
            api.get(`/account/commodities/charges/${formik.values.member_com_acc}`, {
                headers: {
                Authorization: 'Bearer ' + fetchToken()
                }
            }).then(function (response){
                setCharges_ware(response.data);
            }).catch(function (error){
                console.log(error)
            })
        }
    },[formik.values.member_com_acc])

    const fetch_warehouses = () => {
        api.get(`/account/member_bags/warehouses/${member_acc_id}`,{
            headers: {
              Authorization: 'Bearer '+ fetchToken()
            }
          }).then(function(response){
              setWarehouses(response.data?.data);
          }).catch(function(error){
            console.log(error)
          })
    }

    const fetch_details_trs = () => {
        const data = new FormData()
        data.append('member_acc_id', member_acc_id)
        data.append('crop_id', hold_crop_id)
        
        api.post('/account/member/production/account/details/get/trs', data,{
          headers: {
            Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function(response){
            setDeeper_details(response.data?.details);
            setPaid_savings(response.data?.details.savings);
            setPaid_name(response.data?.details.savings_name);
            setCharges_done(response.data?.charges);
            setBags_clock(response.data?.details?.bags);
            setBags_unit(response.data?.details?.unit);
            setCurrent_services(response.data?.services);
            setCurrent_inputs(response.data?.inputs);
            props.fetchAccounts();
        }).catch(function(error){
          console.log(error)
        })
        
        api.get(`/account/grade/values/${hold_crop_id}`, {
            headers: {
                Authorization: 'Bearer ' + fetchToken()
            }
        }).then(function (response){
            setGrade_price(response.data?.grades);
            setAvailable_units(response.data?.units_kg);
        }).catch(function(error){
            console.log(error)
        })
    }
    const addCharge = () => {
        const maxIndexId = Math.max(...charges.map((field) => field.index_id), 0);
        const nextIndexId = maxIndexId + 1;
    
        let new_object = {
            index_id: nextIndexId,
            charge: null,
            amount_per: null
        }
        setCharges([...charges, new_object])
      }
    
      const removeCharge = (index_id) => {
        const indexToRemove = charges.findIndex((field) => field.index_id === index_id);
      
        if (indexToRemove !== -1) {
          const updatedFormFields = [...charges];
          updatedFormFields.splice(indexToRemove, 1);
          setCharges(updatedFormFields);
        }
      };

      const handleCharges = () => {
        handleOpen()
        const data = {
            'prod_id': deeper_details.id,
            'per': per,
            'charges': charges
        }

        api.post('/account/member_bags/charges', data,{
            headers: {
              Authorization: 'Bearer '+ fetchToken()
            }
          }).then(function(response){
              setMessage(response.data);
              setOpe(true);
              fetch_details_trs();
              setCharges([
                {
                    index_id: 0,
                    charge: null,
                    amount_per: null
                }
              ])
          }).catch(function(error){
            console.log(error)
          }).finally(function(){
            handleCloses();
          })
      }

      const handleChange = (index, event, what) => {
        if(what === 'charge'){
            const updatedFormFields = [...charges];
            updatedFormFields[index].charge = event.target.value;
            setCharges(updatedFormFields);
        }else{
            const updatedFormFields = [...charges];
            updatedFormFields[index].amount_per = event.target.value;
            setCharges(updatedFormFields);
        }
        
      }

    const handleCloses = () => {
      setOpenn(false);
    };
    const handleOpen = () => {
      setOpenn(true);
    };

    const close = () => {
        props.setOpen_acc()
    }
    

// {
//         index_id: 0,
//         product_id: null,
//         interest_type: '',
//         private_interest: null,
//         product_type:'',
//         interest_months: '',
//         subscribe: false,
//         service: '',
//         service_price_per_acre: null,
//         interest_percentage_rate_anum: null
//     }
    

    const changeSliderValue = (e) => {
        setSlider_value(e.target.value);
    }

    const doNothing = () => {
        null
    }

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
    });

    const closeStore = () => {
        formik.handleReset()
        setModal_open(false);
      };

    const handleTransfer = (type) => {
        setModal_open(true);
        setModal_type(type);
    }

    const fetch_details = () => {
        api.get(`/account/member/production/account/details/${props.ID}`,{
          headers: {
            Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function(response){
            setDetails(response.data);
            setCrops(response.data.crops);
        }).catch(function(error){
          console.log(error)
        })
    }


    useEffect(() => {
        if(hold_crop_id){
            fetch_details_trs();
        }
    }, [hold_crop_id])

    const openLoanProducts = (commodity, commodity_id, acres) => {
        setHold_crop(commodity);
        setHold_acres(acres);
        setHold_crop_id(commodity_id);
        handleOpen()
        api.get(`/association/production/loan/view/one/${commodity_id}`, {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response) {
            // services
            const new_objects = response.data.services.map((one, index) => { 
                return {
                    index_id: subscribed_s.length + index + 1,
                    product_id: one.id,
                    interest_type: '',
                    private_interest: null,
                    interest_months: null,
                    product_type:'',
                    subscribe: false,
                    service: one.service,
                    service_price_per_acre: one.service_price_per_acre,
                    interest_percentage_rate_anum: one.interest_percentage_rate_anum
                }
            });

            setSubscribed_s([...subscribed_s, ...new_objects]);
            // inputs
            const new_object = response.data.inputs.map((one, index) => { 
                return {
                    index_id: subscribed_i.length + index + 1,
                    product_id: one.id,
                    company: one.company,
                    quantity: one.quantity_per_acre,
                    interest_type: '',
                    private_interest: null,
                    interest_months: null,
                    product_type:'',
                    subscribe: false,
                    input: one.input,
                    input_price_per_acre: one.input_price_per_acre,
                    interest_percentage_rate_anum: one.interest_percentage_rate_anum
                }
            });

            setSubscribed_i([...subscribed_i, ...new_object]);
            
        }).catch(function (error){
            console.log(error)
        }).finally(function(){
            handleCloses()
        })
    }
   
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1200,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };

      const style_transfer = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };


    const handleClo = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpe(false);
      };
  
      const actio = (
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClo}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );


    useEffect(() => {
        fetch_details();
        fetch_warehouses();
    },[])

    const handleSummarize = () => {
        const data = {
            'acres_planting': slider_value,
            'services': subscribed_s,
            'inputs': subscribed_i
        }
        handleOpen()
        api.post('/association/summarize/subscription', data ,{
            headers: {
              Authorization: 'Bearer '+ fetchToken()
            }
          }).then(function(response){
              setService_subscribed(response.data?.services);
              setInput_subscribed(response.data?.inputs);
              setDeep_details(response.data);
          }).catch(function(error){
            console.log(error)
          }).finally(function(){
            handleCloses()
          })
    }

    const handleConfirmLoan = () => {
        const data = {
            'acres_planting': slider_value,
            'services': subscribed_s,
            'inputs': subscribed_i,
            'crop_id': hold_crop_id,
            'member_acc_id': member_acc_id
        }
        handleOpen()
        api.post('/association/confirmed/subscription', data ,{
            headers: {
              Authorization: 'Bearer '+ fetchToken()
            }
          }).then(function(response){
              setMessage(response.data);
              setOpe(true);
              fetch_details_trs();
          }).catch(function(error){
            console.log(error)
          }).finally(function(){
            handleCloses()
          })
    }


    const printRef = React.useRef();
  const printRef_ret = React.useRef();
  // const [print, setPrint] = useState()

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
  
    
    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25; 
  
    pdf.addImage(
      data,
      'PNG',
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );
  
    pdf.save('Commodity.pdf');
  };
   
    
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Item>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <Typography textAlign='center' variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{props.name}</b> 
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={12} sx={{ display:'flex' }}>
                        <div>
                            <b>{renderTitle('Season start',new Date(details?.season?.start_date))}</b> 
                        </div>
                        <div style={{ marginLeft:'auto' }}>
                            {
                                details?.season_status === 'Not Started'?
                                <Chip
                                    color="warning"
                                    variant="outlined"
                                    label={details?.season_status}
                                    sx={{
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                        minWidth: 0,
                                    }} 
                                    size='small'
                                />
                                :details?.season_status === "Ongoing"
                                ? <Chip
                                    color="success"
                                    label={details?.season_status}
                                    sx={{
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                        minWidth: 0
                                    }} 
                                    size='small'
                                />
                                :details?.season_status === "Ended"
                                ?<Chip
                                    color="action"
                                    label={details?.season_status}
                                    sx={{
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                        minWidth: 0
                                    }} 
                                    size='small'
                                />
                                :
                                null   
                            }
                            </div>
                        <div style={{ marginLeft:'auto' }}>
                            {
                                details?.season?.end_date?
                                <b>{renderTitle('Season End',new Date(details?.season?.end_date))}</b>
                                : <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Season End: Not available  yet</b>
                                </Typography>
                            }
                        </div>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Accordion sx={{ borderRadius:2, mb:2 }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel3a-header"
                                display='flex'
                            >
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>What are we cultivating this season?</b></Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Your Crops</b></Typography>
                                <Box sx={{ 
                                    display:'flex', 
                                    flexWrap:'wrap' , 
                                    overflowY: 'auto', 
                                    maxHeight: 200, 
                                    '&::-webkit-scrollbar': {
                                        width: '3px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                    } 
                                }}
                                >
                                    {
                                        crops && crops.map((teo, index) => (
                                            teo.main_crop ? (
                                            <Tooltip key={index} title={'Main Crop'}>
                                                <Chip
                                                    label={`${teo.commodity} | ${teo.land_size ? `${teo.land_size} acres` : "N/A"}`}
                                                    onDelete={doNothing}
                                                    onClick={() => openLoanProducts(teo.commodity, teo.id, teo.land_size)}
                                                    deleteIcon={<CheckCircleIcon />}
                                                    sx={{ m:'5px', borderRadius: 2, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)', }}
                                                />
                                            </Tooltip>
                                            ) : (
                                            <Chip
                                                key={index}
                                                onClick={() => openLoanProducts(teo.commodity, teo.id, teo.land_size)}
                                                label={`${teo.commodity} | ${teo.land_size ? `${teo.land_size} acres` : "N/A"}`}
                                                sx={{ m:'5px', borderRadius: 2, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)', }}
                                            />
                                            )
                                        ))
                                    }
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                {
                    deeper_details?
                    <Grid item xs={12} md={8}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                {
                                    deeper_details.settled?
                                    <Tooltip title={(
                                        <Typography sx={{ textAlign:'center' }} variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Loan Repaid</b>
                                        </Typography>
                                    )}>
                                        <Typography sx={{ textAlign:'center' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Outstanding Loan: <span style={{textDecoration:'line-through'}}>{currencyFormat.format(deeper_details?.accumulative_cost)}</span></b>
                                        </Typography>
                                    </Tooltip>
                                    :
                                    <Typography sx={{ textAlign:'center' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Outstanding Loan: {currencyFormat.format(deeper_details?.accumulative_cost)}</b>
                                    </Typography>
                                }
                                
                                
                                {
                                    bags_clock?
                                    <Tooltip title={
                                        <Typography variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Unit (kg): {bags_unit}</b>
                                        </Typography>
                                    }>
                                        <Typography variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Bags harvested: {bags_clock}</b>
                                        </Typography>
                                    </Tooltip>
                                :null
                                }
                            
                                <Typography variant='h6' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Acres: {deeper_details.acres}</b>
                                </Typography>
                                <Divider sx={{ m:1 }}>Services</Divider>
                                    <Box sx={{  display:'flex', flexWrap:'wrap', mb:1 ,maxHeight: 100, overflowY: 'auto', 
                                        '&::-webkit-scrollbar': {
                                            width: '7px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#f1f1f1',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            background: '#888',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            background: '#555',
                                    }}}>
                                        {
                                            current_services?.map((service) =>(
                                                <>
                                                    <Tooltip title={
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={12} md={12}>
                                                                <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                    <b> Total cost: {currencyFormat.format(service.cost)}</b> 
                                                                </Typography>   
                                                                {
                                                                    service.interest_type === 'percentage_rate'?
                                                                    <>
                                                                        <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b> Private Interest: {`${service.personal_interest}%`}</b> 
                                                                        </Typography>
                                                                        <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Period: {`${service.months} month(s)`}</b> 
                                                                        </Typography>
                                                                    </>
                                                                    
                                                                    : 
                                                                    <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                        <b> Private Interest: {currencyFormat.format(service.personal_interest)}</b> 
                                                                    </Typography> 
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    }>
                                                        <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <Chip
                                                                color="success"
                                                                variant="outlined"
                                                                label={service.service}
                                                                sx={{
                                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                                    minWidth: 0,
                                                                    m:1
                                                                }} 
                                                                size='small'
                                                            />
                                                        </Typography>
                                                    </Tooltip>
                                                </>
                                            ))
                                        }
                                    </Box>
                                <Divider sx={{ m:1 }}>Inputs</Divider>
                                    <Box sx={{ display:'flex', flexWrap:'wrap', mb:1 ,maxHeight: 100, overflowY: 'auto', '&::-webkit-scrollbar': {
                                            width: '7px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#f1f1f1',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            background: '#888',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            background: '#555',
                                    }}}>
                                        {
                                            current_inputs?.map((input) =>(
                                                <>
                                                    <Tooltip title={
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={12} md={12}>
                                                                <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                    <b> Total cost: {currencyFormat.format(input.cost)}</b> 
                                                                </Typography>   
                                                                {
                                                                    input.interest_type === 'percentage_rate'?
                                                                    <>
                                                                        <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b> Private Interest: {`${input.personal_interest}%`}</b> 
                                                                        </Typography>
                                                                        <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Period: {`${input.months} month(s)`}</b> 
                                                                        </Typography>
                                                                    </>
                                                                    
                                                                    : 
                                                                    <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                        <b> Private Interest: {currencyFormat.format(input.personal_interest)}</b> 
                                                                    </Typography> 
                                                                }
                                                                <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                    <b>Company: {input.company}</b> 
                                                                </Typography>
                                                                <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                    <b>Quantity: {input.total_quantity}</b> 
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    }>
                                                        <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <Chip
                                                            color="success"
                                                            variant="outlined"
                                                            label={input.input}
                                                            sx={{
                                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                                minWidth: 0,
                                                                m:1
                                                            }} 
                                                            size='small'
                                                        />
                                                        </Typography>
                                                    </Tooltip>
                                                </>
                                            ))
                                        }
                                    </Box>
                            </Grid>
                            <Grid item xs={12} md={6} sx={{ borderLeft:1, borderColor:'gray' }}>
                                {
                                    charges_done?.charges[0]?
                                        <Box>
                                            <Box sx={{ display:'flex',m:1 }}>
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Charges</b></Typography>
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Total: {currencyFormat.format(charges_done.total_charges)}</b></Typography>
                                            </Box>
                                            <Box sx={{ display:'flex', flexWrap:'wrap', m:1 ,maxHeight: 200, overflowY: 'auto', 
                                                    '&::-webkit-scrollbar': {
                                                        width: '7px',
                                                    },
                                                    '&::-webkit-scrollbar-track': {
                                                        background: '#f1f1f1',
                                                    },
                                                    '&::-webkit-scrollbar-thumb': {
                                                        background: '#888',
                                                        borderRadius: '10px',
                                                    },
                                                    '&::-webkit-scrollbar-thumb:hover': {
                                                        background: '#555',
                                                    }
                                            }}>
                                                {
                                                    charges_done.charges.map((one) => (
                                                        <Tooltip title={
                                                            <Box>
                                                                <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                    <b>Charged per: {one.per}</b> 
                                                                </Typography>
                                                                <Typography textAlign='left' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                    <b>Price per {one.per}: {currencyFormat.format(one.price)}</b> 
                                                                </Typography>
                                                            </Box>
                                                        }>
                                                            <Chip
                                                                color="success"
                                                                variant="outlined"
                                                                label={`${one.charge} | ${currencyFormat.format(one.price_charged)}`}
                                                                sx={{
                                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                                    minWidth: 0,
                                                                    m:1
                                                                }} 
                                                                size='small'
                                                            />
                                                        </Tooltip>
                                                    ))
                                                }
                                            </Box>
                                        </Box>
                                    :
                                    null
                                }
                            </Grid>
                            
                        </Grid>
                        
                    </Grid>
                    :
                        null
                    }

                    {
                        bags_clock?
                        <Grid item xs={12} md={12}>
                            {
                                deeper_details?.settled?
                                <>
                                    <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>{deeper_details.transfered? 'Transferred to warehouse' :deeper_details.withdrawn? 'Withdrawn': ''}</b> 
                                    </Typography>
                                    <Button
                                        disabled={deeper_details.transfered || deeper_details.withdrawn}
                                        sx={{ m:1, borderRadius:4 }} 
                                        color="success" 
                                        size="small" 
                                        onClick={() => handleTransfer(true)}
                                        variant="contained"
                                    >
                                        Keep in Warehouse
                                    </Button>
                                    <Button
                                        disabled={deeper_details.withdrawn || deeper_details.transfered}
                                        sx={{ m:1, borderRadius:4 }} 
                                        color="success" 
                                        size="small" 
                                        onClick={Withdraw}
                                        variant="contained"
                                    >
                                        Withdraw
                                    </Button>
                                </>
                                : deeper_details?.warehouse?
                                <>
                                    <Button
                                        sx={{ m:1, borderRadius:4 }} 
                                        color="success" 
                                        size="small" 
                                        disabled
                                        variant="contained"
                                    >
                                        {deeper_details?.warehouse}
                                    </Button>
                                    <Button
                                        sx={{ m:1, borderRadius:4 }} 
                                        color="success" 
                                        size="small" 
                                        onClick={() => handleTransfer(false)}
                                        variant="contained"
                                    >
                                        Settle Debt
                                    </Button>
                                </>
                                : deeper_details?.warehouse === null?
                                <>
                                    <Button
                                        variant='contained'
                                        color='success'
                                        size='small'
                                        onClick={handleClick}
                                        sx={{   m:1, 
                                            borderRadius:4,
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                            minWidth: 0,
                                            '&:hover': {
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            backgroundColor:'#80ed99',
                                            color:'#000'
                                            },
                                        }} 
                                        id="demo-positioned-button"
                                        aria-controls={openg ? 'demo-positioned-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={openg ? 'true' : undefined}
                                    >
                                        Choose Warehouse
                                    </Button>
                                    <Menu
                                        id="demo-positioned-menu"
                                        aria-labelledby="demo-positioned-button"
                                        anchorEl={anchorEl}
                                        open={openg}
                                        onClose={handleClose}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left'
                                        }}
                                    >
                                        {
                                            deeper_details?.houses.map((item)=>(
                                                <MenuItem  onClick={() => handleConfirm(item.id)}>
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>{item.warehouse}</b>
                                                    </Typography>
                                                </MenuItem>
                                            ))
                                        }
                                        <MenuItem onClick={handleClose}>
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Cancel</b>
                                            </Typography>
                                        </MenuItem>
                                    </Menu>
                                </>
                                : null
                            }
                            
                        </Grid>
                        :
                        null
                    }

                    {
                        deeper_details? 
                        deeper_details?.status === 'Disbursed'?
                        <Grid item xs={12} md={12}>
                            <Accordion sx={{ borderRadius:2, m:2 }}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel3a-header"
                                    display='flex'
                                >
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Done Harvesting?</b></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2} sx={{ maxHeight: 200, overflowY: 'auto', 
                                                '&::-webkit-scrollbar': {
                                                    width: '7px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: '#f1f1f1',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#888',
                                                    borderRadius: '10px',
                                                },
                                                '&::-webkit-scrollbar-thumb:hover': {
                                                    background: '#555',
                                                } 
                                            }}>
                                        {
                                            details?.season_status !== 'ended'?
                                                <Grid item xs={12} md={12}>
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Season has not yet ended</b></Typography>
                                                </Grid>
                                            :null
                                        }
                                        <Grid item xs={12} md={12}>
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Bags harvested</b>
                                            </Typography>
                                            <div style={{ display:'flex' }}>
                                                <TextField
                                                    size='small'
                                                    sx={{ m:1 }}
                                                    value={bags_clock}
                                                    name='bags_clock'
                                                    label='Bags'
                                                    onChange={(event) =>{ 
                                                        setBags_clock(event.target.value)
                                                        const data = new FormData()
                                                        data.append('prod_id', deeper_details.id)
                                                        data.append('bags', event.target.value)
                                                        data.append('unit', bags_unit?bags_unit:0)
                                                        
                                                        api.post('/account/member_bags/prod_id', data,{
                                                            headers: {
                                                                Authorization: 'Bearer '+ fetchToken()
                                                            }
                                                        }).catch(function(error){
                                                            console.log(error)
                                                        })
                                                    }}
                                                    type='number'
                                                    disabled={deeper_details && deeper_details?.settled}
                                                />
                                                <TextField
                                                    size='small'
                                                    sx={{ m:1 }}
                                                    value={bags_unit}
                                                    name='bags_unit'
                                                    label='Units (kg)'
                                                    onChange={(event) =>{ 
                                                        setBags_unit(event.target.value)
                                                        const data = new FormData()
                                                        data.append('prod_id', deeper_details.id)
                                                        data.append('unit', event.target.value)
                                                        data.append('bags', bags_clock?bags_clock:0)
                                                        
                                                        api.post('/account/member_bags/prod_id', data,{
                                                            headers: {
                                                                Authorization: 'Bearer '+ fetchToken()
                                                            }
                                                        }).catch(function(error){
                                                            console.log(error)
                                                        })
                                                    }}
                                                    type='number'
                                                    inputProps={{ step: 'any' }}
                                                    disabled={deeper_details && deeper_details.settled}
                                                />
                                            </div>
                                            
                                        <Divider sx={{ m:1 }} variant='middle'>
                                            <div style={{ display: 'flex' }}>
                                                <Typography sx={{ margin:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Per acre</b></Typography> 
                                                <Switch
                                                    checked={per}
                                                    onChange={(event) => setPer(event.target.checked)}
                                                    sx={{color:'#001845'}}
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />
                                                <Typography sx={{ margin:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Per bag</b></Typography>
                                            </div>
                                        </Divider>
                                        </Grid>
                                        {
                                            bags_clock?
                                                charges[0] && charges.map((charge, index) => (
                                                    <>
                                                        <Grid item xs={12} md={6}>
                                                            <TextField 
                                                                size='small'
                                                                value={charges[charge.index_id].charge}
                                                                onChange={(event) => handleChange(charge.index_id, event, 'charge')}
                                                                name='charge'
                                                                helperText={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Charge</b></Typography>}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6} sx={{ display:'flex', flexDirection:'row' }}>
                                                            <TextField 
                                                                size='small'
                                                                value={charges[charge.index_id].amount_per}
                                                                onChange={(event) => handleChange(charge.index_id, event, 'amount_per')}
                                                                name='amount_per'
                                                                helperText={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{`Price per ${per?'Bag':'Acre'}`}</b></Typography>}
                                                            />
                                                            <IconButton disabled={charges.length > 1?false:true} sx={{ mb:'auto' }} onClick={() => removeCharge(charge.index_id)}><RemoveCircleIcon /></IconButton>
                                                        </Grid>
                                                        <Grid item xs={12} md={12}>
                                                        <Divider variant='middle' /> 
                                                        </Grid>
                                                    </>
                                                ))
                                                    
                                            :null
                                        }

                                        <Grid item xs={12} md={12}>
                                            {
                                                charges[0] &&
                                                <Button sx={{ m:1, backgroundColor:'#33415c', borderRadius:4 }} size="small" disabled={bags_clock?false:true} onClick={addCharge} variant="contained">Add Charges</Button>
                                            }
                                            {
                                                charges[0] &&
                                                <Button
                                                    disabled={charges[0].charge !== null && charges[0].amount_per !== null && deeper_details.settled === false?false:true}
                                                    sx={{ m:1, borderRadius:4 }} 
                                                    color="success" 
                                                    size="small" 
                                                    onClick={handleCharges}
                                                    variant="contained"
                                                >
                                                    Done
                                                </Button>
                                            }
                                            
                                        </Grid>
                                        
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        :
                        <Grid item xs={12} md={12}>
                            <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Loan Requested. <br/><span style={{ fontStyle:'italic' }}>loans would be signed and disbursed in groups in the savings group.</span></b>
                            </Typography>   
                            <Box sx={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                                <Chip
                                    color="success"
                                    variant="outlined"
                                    label={
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Loan Status: {deeper_details?.status}</b>
                                            </Typography>
                                            }
                                    sx={{
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                        minWidth: 0,
                                        m:1
                                    }} 
                                    size='small'
                                />
                                <Chip
                                    color="success"
                                    variant="outlined"
                                    label={
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Signed: {deeper_details?.signed}</b>
                                        </Typography>
                                        }
                                    sx={{
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                        minWidth: 0,
                                        m:1
                                    }} 
                                    size='small'
                                />
                            </Box>
                        </Grid>
                        :
                        null
                    }
                    

                    <Grid item xs={12} md={12}>
                        {
                            hold_crop?
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                    <Typography variant='h4' textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Services and Inputs Available for {hold_crop}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Your land size for {hold_crop}: {hold_acres? `${hold_acres} acres`: 'N/A'}</b>
                                    </Typography>
                                    <Typography
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        variant='body2'
                                    >
                                        <b>Acres using: {slider_value}</b>
                                        </Typography>

                                        <PrettoSlider
                                            valueLabelDisplay="auto"
                                            aria-label="pretto slider"
                                            value={slider_value}
                                            onChange={changeSliderValue}
                                            step={1}
                                            size="small"
                                            max={hold_acres?hold_acres:100}
                                            marks
                                            sx={{ mb:2 }}
                                        />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography variant='h5' textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Subscribe to Services</b>
                                    </Typography>
                                    <Box sx={{ mb:1 ,maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                            width: '7px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#f1f1f1',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            background: '#888',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            background: '#555',
                                    }}}>
                                        {
                                        subscribed_s.map((service) => (
                                            <ItemCard>
                                                <Typography sx={{ color:'#000', textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>{service.service}</b> 
                                                </Typography>
                                                <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Cost: {currencyFormat.format(service.service_price_per_acre)} per acre</b> 
                                                </Typography>
                                                <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Interest/anum: {service.interest_percentage_rate_anum}% </b> 
                                                </Typography> 

                                                <Accordion 
                                                    sx={{ borderRadius:2, mb:2 }}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel2a-content"
                                                        id="panel3a-header"
                                                        display='flex'
                                                    >
                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Private interest?</b></Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <FormControl>
                                                            <FormLabel id="demo-row-radio-buttons-group-label">Type</FormLabel>
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name='interest_type'
                                                                value={subscribed_s.find(item => item.product_id === service.product_id)?.interest_type || ''}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const updatedSubscribed_s = subscribed_s.map(item => {
                                                                        if (item.product_id === service.product_id) {
                                                                            return {
                                                                                ...item,
                                                                                interest_type: value
                                                                            };
                                                                        }
                                                                        return item;
                                                                    });
                                                                    setSubscribed_s(updatedSubscribed_s);
                                                                }}
                                                            >
                                                                <FormControlLabel value="flat_rate" control={<Radio />} label="Fixed Amount" />
                                                                <FormControlLabel value="percentage_rate" control={<Radio />} label="Percentage Rate" />
                                                                <FormControlLabel value="" control={<Radio />} label="Default" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                        {
                                                            subscribed_s.find(item => item.product_id === service.product_id)?.interest_type === 'flat_rate'?(
                                                                <TextField
                                                                    size='small'
                                                                    type='number'
                                                                    variant='standard'
                                                                    label='Type here'
                                                                    inputProps={{ step: 'any' }}
                                                                    name='private_interest'
                                                                    value={subscribed_s.find(item => item.product_id === service.product_id)?.private_interest || null}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        const updatedSubscribed_s = subscribed_s.map(item => {
                                                                            if (item.product_id === service.product_id) {
                                                                                return {
                                                                                    ...item,
                                                                                    private_interest: value
                                                                                };
                                                                            }
                                                                            return item;
                                                                        });
                                                                        setSubscribed_s(updatedSubscribed_s);
                                                                    }}
                                                                />
                                                            ): subscribed_s.find(item => item.product_id === service.product_id)?.interest_type === 'percentage_rate'?(
                                                                <>
                                                                <TextField
                                                                    size='small'
                                                                    type='number'
                                                                    variant='standard'
                                                                    label='Type here (%)'
                                                                    inputProps={{ step: 'any' }}
                                                                    name='private_interest'
                                                                    value={subscribed_s.find(item => item.product_id === service.product_id)?.private_interest || null}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        const updatedSubscribed_s = subscribed_s.map(item => {
                                                                            if (item.product_id === service.product_id) {
                                                                                return {
                                                                                    ...item,
                                                                                    private_interest: value
                                                                                };
                                                                            }
                                                                            return item;
                                                                        });
                                                                        setSubscribed_s(updatedSubscribed_s);
                                                                    }}
                                                                />

                                                                <TextField
                                                                    size='small'
                                                                    type='number'
                                                                    variant='standard'
                                                                    label='number of months'
                                                                    name='interest_months'
                                                                    value={subscribed_s.find(item => item.product_id === service.product_id)?.interest_months || null}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        const updatedSubscribed_s = subscribed_s.map(item => {
                                                                            if (item.product_id === service.product_id) {
                                                                                return {
                                                                                    ...item,
                                                                                    interest_months: value
                                                                                };
                                                                            }
                                                                            return item;
                                                                        });
                                                                        setSubscribed_s(updatedSubscribed_s);
                                                                    }}
                                                                />
                                                                
                                                                </>
                                                            ):null
                                                        }
                                                    </AccordionDetails>
                                                </Accordion>

                                                {/* <Button sx={{ m:1, backgroundColor:'#eb5e28', borderRadius:4 }} size="small"  variant="contained">
                                                    Private interest
                                                </Button> */}
                                                <Button 
                                                    sx={{ 
                                                        m:1, 
                                                        backgroundColor: subscribed_s.find(item => item.product_id === service.product_id)?.subscribe === true? '#bc6c25': '#eb5e28' , 
                                                        borderRadius:4 
                                                    }} 
                                                    size="small"  
                                                    variant="contained"
                                                    onClick={() => {
                                                        const updatedSubscribed_s = subscribed_s.map(one => {
                                                            if (one.product_id === service.product_id) {
                                                                return {
                                                                    ...one,
                                                                    subscribe: !one.subscribe
                                                                };
                                                            }
                                                            return one;
                                                        });
                                                        setSubscribed_s(updatedSubscribed_s);
                                                    }}
                                                >
                                                    {
                                                        subscribed_s.find(item => item.product_id === service.product_id)?.subscribe === true?
                                                        'Unsubscribe'
                                                        :
                                                        'Subscribe'
                                                    }
                                                    
                                                </Button>
                                                
                                            </ItemCard>
                                        ))
                                    }
                                    </Box>
                                    
                                </Grid>

                                {/* Inputs */}
                                <Grid item xs={12} md={6}>
                                    <Typography variant='h5' textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Subscribe for Farm Inputs</b>
                                    </Typography>
                                    <Box sx={{ mb:1 ,maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                            width: '7px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#f1f1f1',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            background: '#888',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            background: '#555',
                                    }}}>
                                        {
                                        subscribed_i.map((input) => (
                                            <ItemCardI>
                                                <Typography sx={{ color:'#000', textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>{input.input}</b> 
                                                </Typography>
                                                <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Cost: {currencyFormat.format(input.input_price_per_acre)} per acre</b> 
                                                </Typography>
                                                <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Company: {input.company}</b> 
                                                </Typography>
                                                <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Quantity per acre: {input.quantity} (kg/g/liters/bags/...)</b> 
                                                </Typography>
                                                <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>Interest/anum: {input.interest_percentage_rate_anum}% </b> 
                                                </Typography> 

                                                <Accordion 
                                                    sx={{ borderRadius:2, mb:2 }}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel2a-content"
                                                        id="panel3a-header"
                                                        display='flex'
                                                    >
                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Private interest?</b></Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <FormControl>
                                                            <FormLabel id="demo-row-radio-buttons-group-label">Type</FormLabel>
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name='interest_type'
                                                                value={subscribed_i.find(item => item.product_id === input.product_id)?.interest_type || ''}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const updatedSubscribed_i = subscribed_i.map(item => {
                                                                        if (item.product_id === input.product_id) {
                                                                            return {
                                                                                ...item,
                                                                                interest_type: value
                                                                            };
                                                                        }
                                                                        return item;
                                                                    });
                                                                    setSubscribed_i(updatedSubscribed_i);
                                                                }}
                                                            >
                                                                <FormControlLabel value="flat_rate" control={<Radio />} label="Fixed Amount" />
                                                                <FormControlLabel value="percentage_rate" control={<Radio />} label="Percentage Rate" />
                                                                <FormControlLabel value="" control={<Radio />} label="Default" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                        {
                                                            subscribed_i.find(item => item.product_id === input.product_id)?.interest_type === 'flat_rate'?(
                                                                <TextField
                                                                    size='small'
                                                                    type='number'
                                                                    variant='standard'
                                                                    label='Type here'
                                                                    inputProps={{ step: 'any' }}
                                                                    name='private_interest'
                                                                    value={subscribed_i.find(item => item.product_id === input.product_id)?.private_interest || null}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        const updatedSubscribed_i = subscribed_i.map(item => {
                                                                            if (item.product_id === input.product_id) {
                                                                                return {
                                                                                    ...item,
                                                                                    private_interest: value
                                                                                };
                                                                            }
                                                                            return item;
                                                                        });
                                                                        setSubscribed_i(updatedSubscribed_i);
                                                                    }}
                                                                />
                                                            ): subscribed_i.find(item => item.product_id === input.product_id)?.interest_type === 'percentage_rate'?(
                                                                <>
                                                                    <TextField
                                                                        size='small'
                                                                        type='number'
                                                                        variant='standard'
                                                                        label='Type here (%)'
                                                                        inputProps={{ step: 'any' }}
                                                                        name='private_interest'
                                                                        value={subscribed_i.find(item => item.product_id === input.product_id)?.private_interest || null}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            const updatedSubscribed_i = subscribed_i.map(item => {
                                                                                if (item.product_id === input.product_id) {
                                                                                    return {
                                                                                        ...item,
                                                                                        private_interest: value
                                                                                    };
                                                                                }
                                                                                return item;
                                                                            });
                                                                            setSubscribed_i(updatedSubscribed_i);
                                                                        }}
                                                                    />
                                                                    <TextField
                                                                        size='small'
                                                                        type='number'
                                                                        variant='standard'
                                                                        label='number of months'
                                                                        name='interest_months'
                                                                        value={subscribed_i.find(item => item.product_id === input.product_id)?.interest_months || null}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            const updatedSubscribed_i = subscribed_i.map(item => {
                                                                                if (item.product_id === input.product_id) {
                                                                                    return {
                                                                                        ...item,
                                                                                        interest_months: value
                                                                                    };
                                                                                }
                                                                                return item;
                                                                            });
                                                                            setSubscribed_i(updatedSubscribed_i);
                                                                        }}
                                                                    />
                                                                    
                                                                </>
                                                            ):null
                                                        }
                                                    </AccordionDetails>
                                                </Accordion>

                                                {/* <Button sx={{ m:1, backgroundColor:'#eb5e28', borderRadius:4 }} size="small"  variant="contained">
                                                    Private interest
                                                </Button> */}
                                                <Button 
                                                    sx={{ 
                                                        m:1, 
                                                        backgroundColor: subscribed_i.find(item => item.product_id === input.product_id)?.subscribe === true? '#bc6c25': '#eb5e28' , 
                                                        borderRadius:4 
                                                    }} 
                                                    size="small"  
                                                    variant="contained"
                                                    onClick={() => {
                                                        const updatedSubscribed_i = subscribed_i.map(one => {
                                                            if (one.product_id === input.product_id) {
                                                                return {
                                                                    ...one,
                                                                    subscribe: !one.subscribe
                                                                };
                                                            }
                                                            return one;
                                                        });
                                                        setSubscribed_i(updatedSubscribed_i);
                                                    }}
                                                >
                                                    {
                                                        subscribed_i.find(item => item.product_id === input.product_id)?.subscribe === true?
                                                        'Unsubscribe'
                                                        :
                                                        'Subscribe'
                                                    }
                                                    
                                                </Button>
                                                
                                            </ItemCardI>
                                        ))
                                    }
                                    </Box>
                                    
                                </Grid>

                                

                            </Grid>
                            :
                            null
                        }
                    </Grid>
                

                    {
                        service_subscribed[0] || input_subscribed[0]?
                            <Grid item xs={12} md={12}>
                                <Typography variant='h4' sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Complete Subscription</b>
                                </Typography>
                                <Typography variant='h6' sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Accumulated Cost: {currencyFormat.format(deep_details.accumulative_cost)}</b>
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant='h5' sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Subscribed Services</b> 
                                        </Typography>
                                        <Typography variant='h6' sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Total service cost {currencyFormat.format(deep_details.service_cost)}</b> 
                                        </Typography>
                                        <div style={{ display:'flex', flexWrap:'wrap', maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                                    width: '7px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: '#f1f1f1',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#888',
                                                    borderRadius: '10px',
                                                },
                                                '&::-webkit-scrollbar-thumb:hover': {
                                                    background: '#555',
                                            }}}>
                                            {
                                                service_subscribed.map((service) => (
                                                    <ItemCardSS>
                                                        <Typography sx={{ color:'#000', textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>{service.service}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Cost: {currencyFormat.format(service.cost)}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Interest Type: {service.interest_type === 'flat_rate'? 'Fixed Amount': 'Percentage rate'}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Interest Amount: {currencyFormat.format(service.interest)}</b> 
                                                        </Typography>
                                                        {
                                                            service.interest_type === 'percentage_rate'?
                                                            <>
                                                            <Divider variant='middle' />
                                                            <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>Number of months: {service.months}</b> 
                                                            </Typography>
                                                            </>:
                                                            null
                                                        }
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Total Cost: {currencyFormat.format(service.total_cost)} </b> 
                                                        </Typography>
                                                    </ItemCardSS>
                                                ))
                                                
                                            }
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Typography variant='h5' sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Subscribed Inputs</b> 
                                        </Typography>
                                        <Typography variant='h6' sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Total inputs cost {currencyFormat.format(deep_details.input_cost)}</b> 
                                        </Typography>
                                        <div style={{ display:'flex', flexWrap:'wrap', maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                                    width: '7px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: '#f1f1f1',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#888',
                                                    borderRadius: '10px',
                                                },
                                                '&::-webkit-scrollbar-thumb:hover': {
                                                    background: '#555',
                                            }}}>
                                        {
                                                input_subscribed.map((input) => (
                                                    <ItemCardSI>
                                                        <Typography sx={{ color:'#000', textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>{input.input}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Company: {input.company}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Quantity needed: {input.quantity_needed}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Cost: {currencyFormat.format(input.cost)}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Interest Type: {input.interest_type === 'flat_rate'? 'Fixed Amount': 'Percentage rate'}</b> 
                                                        </Typography>
                                                        {
                                                            input.interest_type === 'percentage_rate'?
                                                            <>
                                                            <Divider variant='middle' />
                                                            <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>Number of months: {input.months}</b> 
                                                            </Typography>
                                                            </>:
                                                            null
                                                        }
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Interest Amount: {currencyFormat.format(input.interest)}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Total Cost: {currencyFormat.format(input.total_cost)} </b> 
                                                        </Typography>
                                                    </ItemCardSI>
                                                ))
                                                
                                            }
                                        </div>
                                    </Grid>
                                </Grid>
                                
                            </Grid>
                        :
                        null
                    }
                    

                    {
                        hold_crop?
                        <Grid item xs={12} md={6}>
                            <Button 
                                size='small' 
                                sx={{ 
                                    m:1, 
                                    borderRadius:4,
                                    backgroundColor:'#eb5e28',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                    minWidth: 0,
                                    '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                    },
                                }} 
                                variant='contained' 
                                onClick={handleSummarize}
                                disabled={deeper_details && deeper_details.settled}
                            >
                                {
                                    service_subscribed[0] || input_subscribed[0]?
                                    'Refresh'
                                    :
                                    'Summarize'
                                }
                                
                            </Button>
                            {
                                service_subscribed[0] || input_subscribed[0]?
                                <Button 
                                    size='small' 
                                    sx={{ 
                                        m:1, 
                                        borderRadius:4,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                        minWidth: 0,
                                        '&:hover': {
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        },
                                    }} 
                                    variant='contained' 
                                    color='success' 
                                    onClick={handleConfirmLoan}
                                    disabled={deeper_details && deeper_details.settled}
                            >
                                Confirm loan 
                            </Button>
                                : null
                            }
                            
                        </Grid>
                        :
                        null
                    }
                    
                    
                    <Grid item xs={12} md={12}>
                        <Button
                            sx={{ m:2,
                                borderRadius:4,
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                minWidth: 0,
                                '&:hover': {
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                }, }}
                            onClick={close}
                            variant='contained'
                            size='small'
                            color='warning'
                        >
                            Close
                        </Button>
                        <Button
                            sx={{ m:2, 
                                borderRadius:4,
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                minWidth: 0,
                                '&:hover': {
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                }, }}
                            onClick={()=>setOpen(true)}
                            variant='contained'
                            size='small'
                            color='warning'
                        >
                            Delete Account
                        </Button>
                    </Grid>
                </Grid>
                <Modal
                    open={modal_open}
                    onClose={closeStore}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                > 
                    <Box sx={style_transfer}>
                        {second_modal}
                        {
                            warehouses?
                                <Grid container spacing={2}>
                                    <form onSubmit={formik.handleSubmit}>
                                    <Grid item xs={12} md={12}>
                                        <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            {
                                                modal_type?
                                                (<b>Transfer bags to warehouse</b>) 
                                                :(<b>Calculate value of bags</b>)
                                            }
                                        </Typography>
                                    </Grid>
                                        {/* {
                                            modal_type? */}
                                            <Grid item xs={12} md={12}>
                                                <Autocomplete
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    options={warehouses}
                                                    sx={{ width: 300, mt:3, marginBottom:1 }}
                                                    getOptionLabel={(option) => option.warehouse}
                                                    getOptionDisabled={(option) =>
                                                        option.ware_id !== deeper_details.warehouse_id
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    onChange={(event, value) => {
                                                        if (value) {
                                                            formik.setFieldValue("member_com_acc", value.id)
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Select Warehouse" size="small" />}
                                                />
                                            </Grid>
                                        {/* :null
                                        } */}
                                        
                                        <Grid item xs={12} md={12}>
                                            {
                                                grade_price[0]?
                                                <>
                                                    <Select
                                                        margin="dense"
                                                        required
                                                        name="grade_id"
                                                        onChange={(e) => formik.setFieldValue('grade_id',e.target.value)}
                                                        value={formik.values.grade_id}
                                                        fullWidth
                                                        size='small'
                                                        variant="outlined"
                                                    >
                                                        {
                                                            grade_price.map((item) => (
                                                                <MenuItem value={item.id}>{item.grade}</MenuItem>
                                                            ))
                                                        }
                                                    </Select>
                                                    <FormHelperText sx={{ marginBottom:1 }}>Set Grade</FormHelperText>
                                                    <Select
                                                        margin="dense"
                                                        required
                                                        name="unit_id"
                                                        onChange={formik.handleChange}
                                                        value={formik.values.unit_id}
                                                        fullWidth
                                                        size='small'
                                                        variant="outlined"
                                                    >
                                                            {
                                                                available_units.map((item) => item.unit_per_kg === bags_unit?(
                                                                    <MenuItem value={item.id}>{item.unit_per_kg}</MenuItem>
                                                                ): null)
                                                            }
                                                    </Select>
                                                    <FormHelperText sx={{ marginBottom:1 }}>Set Unit\kg (unit must be same as bag units)</FormHelperText>
                                                    
                                                    </>
                                                : null
                                                }
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <DateTimePicker
                                                id="date"
                                                name="date" 
                                                value={formik.values.date}
                                                onChange={(date) => formik.setFieldValue('date', date)}
                                                orientation="landscape"
                                                label="Set DateTime"
                                                size="small"
                                                sx={{ mb:2, mt:1 }}
                                            />
                                        </Grid>
                                        
                                        <Grid item xs={12} md={12}>
                                            {
                                                charges_ware[0]
                                                ?
                                                <>
                                                    <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' }}><b>Charges (per bag)</b></Typography>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox name='rebag' checked={formik.values.rebag} onChange={formik.handleChange} />} label={`Rebag (GHS ${charges_ware[0].rebagging_fee})`} />
                                                        <FormControlLabel control={<Checkbox name='stack' checked={formik.values.stack} onChange={formik.handleChange} />} label={`Stack (GHS ${charges_ware[0].stacking_fee})`} />
                                                        <FormControlLabel control={<Checkbox name='clean' checked={formik.values.clean} onChange={formik.handleChange} />} label={`Clean (GHS ${charges_ware[0].cleaning_fee})`} />
                                                        <FormControlLabel control={<Checkbox name='destone' checked={formik.values.destone} onChange={formik.handleChange} />} label={`Disstone (GHS ${charges_ware[0].destoning_fee})`} />
                                                        <FormControlLabel control={<Checkbox name='store' checked={formik.values.store} onChange={formik.handleChange} />} label={`Store (GHS ${charges_ware[0].storage_fee})`} disabled />
                                                        <FormControlLabel control={<Checkbox name='stitch' checked={formik.values.stitch} onChange={formik.handleChange} />} label={`Stitch (GHS ${charges_ware[0].stitching_fee})`} />
                                                        <FormControlLabel control={<Checkbox name='load' checked={formik.values.load} onChange={formik.handleChange} />} label={`Load (GHS ${charges_ware[0].loading_fee})`} disabled />
                                                        <FormControlLabel control={<Checkbox name='empty_sack' checked={formik.values.empty_sack} onChange={formik.handleChange} />} label={`Sack (GHS ${charges_ware[0].empty_sack_cost_fee})`} />
                                                        <FormControlLabel control={<Checkbox checked={true} />} label={`Tax (GHS ${charges[0].tax_fee})`} disabled />
                                                    </FormGroup>
                                                </>
                                                :
                                                <Box sx={{ width: '100%', justifyContent:'center' }}>
                                                    <CircularProgress size='15'/>
                                                </Box>
                                            }
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <Button
                                                variant='contained'
                                                onClick={closeStore}
                                                color='error'
                                                size='small'
                                                SX={{ m:1, borderRadius:4 }}
                                            >
                                                Cancel
                                            </Button>

                                            <Button
                                                variant='contained'
                                                type='submit'
                                                color='success'
                                                size='small'
                                                sx={{ m:1, borderRadius:4 }}
                                                disabled={
                                                    bags_clock && formik.values.unit_id  && formik.values.grade_id ?
                                                    false: true
                                                }
                                            >
                                                Process
                                            </Button>
                                        </Grid>
                                    </form>
                                </Grid>
                        :
                        <>
                            <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Join warehouse to make transfer</b> 
                            </Typography>
                            <Button
                                variant='contained'
                                onClick={closeStore}
                                color='error'
                                size='small'
                                SX={{ m:1, borderRadius:4 }}
                            >
                                Cancel
                            </Button>
                        </>
                           
                        }
                    </Box>
                </Modal>

                
            <Snackbar
                open={ope}
                autoHideDuration={3000}
                onClose={handleClo}
                message={message}
                action={actio}
            />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openn}
                onClick={handleCloses}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Item>
    </LocalizationProvider>
       
  )

}


    // return(
    //     <Item>
    //     </Item>
    // )